import {
  defaultGetOrderListOrderList,
  exists,
  GetOrderListDetail,
  GetOrderListDetailFromJSON,
  GetOrderListOrderList,
  GetOrderListOrderListFromJSON,
  GetOrderListSelection,
  GetOrderListSelectionFromJSON
} from '@/api'

export interface GetOrderList {
  orderList: GetOrderListOrderList
  orderListDetails: GetOrderListDetail[]
  selections: GetOrderListSelection[]
}

export const defaultGetOrderList = (): GetOrderList => ({
  orderList: defaultGetOrderListOrderList(),
  orderListDetails: [],
  selections: []
})

export function GetOrderListFromJSON(json: any): GetOrderList {
  return {
    orderList: exists(json, 'order_list')
      ? GetOrderListOrderListFromJSON(json.order_list)
      : defaultGetOrderListOrderList(),
    orderListDetails: exists(json, 'order_list_details')
      ? json.order_list_details.map(GetOrderListDetailFromJSON)
      : [],
    selections: exists(json, 'selections')
      ? json.selections.map(GetOrderListSelectionFromJSON)
      : []
  }
}
